import React from "react";

import {
  CustomComponent,
  ExampleSuggestions,
  SENSOR_IDS,
} from "../../components";
import { useReactifySearchContext, useSearch } from "../../hooks";

export type SuggestionsProps = {
  /** The field which should be used for autocompletion */
  field: "title";
  /** Render method */
  render?: React.FC<{
    suggestions: Array<{
      text: string;
    }>;
  }>;
};

export const Suggestions: React.FC<SuggestionsProps> = (props) => {
  const RenderComponent = props.render ?? ExampleSuggestions;

  const reactifySearchContext = useReactifySearchContext();

  const { searchTerm } = useSearch();

  const sensorIds = SENSOR_IDS(reactifySearchContext.options.mode, reactifySearchContext.config);

  return (
    <CustomComponent
      componentId="SensorSuggestions"
      defaultQuery={() => {
        return {
          suggest: {
            suggestions: {
              text: searchTerm,
              term: {
                field: props.field,
                sort: "score",
                suggest_mode: "always",
              },
            },
          },
        };
      }}
      react={{
        and: sensorIds,
      }}
      render={(renderProps) => {
        const props: React.ComponentProps<
          NonNullable<SuggestionsProps["render"]>
        > = {
          suggestions: [],
        };

        if (renderProps.rawData?.suggest?.suggestions.length) {
          const options = renderProps.rawData.suggest.suggestions[renderProps.rawData.suggest.suggestions.length - 1]?.options;
          props.suggestions = (options as Array<{ text: string; freq: number }>).filter((option) => !(reactifySearchContext.config.suggestions.exclude ?? []).includes(option.text)).map((option) => ({
            text: option.text,
          }));
        }

        return <RenderComponent {...props} />;
      }}
    />
  );
};
